/** The server's per-file ceiling (ingest/finalize rejects > 50 MiB). Checked
 * BEFORE reading so an oversized file is refused with a plain message instead of
 * being base64-encoded in memory (~67 MB string) and then rejected. */
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;

/** The friendly refusal for a file over {@link MAX_UPLOAD_BYTES}, or null. */
export function oversizeMessage(file: Pick<File, 'size'>): string | null {
  return file.size > MAX_UPLOAD_BYTES ? 'This file is larger than the 50 MB limit.' : null;
}

/** Read a File and return its bytes as a base64 string (no data: prefix) for the
 * `POST /rooms/:roomId/ingest/finalize` payload. Encodes in chunks so large
 * files don't blow the argument-count limit of String.fromCharCode(...). */
export async function fileToBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  const CHUNK = 0x8000; // 32 KiB per fromCharCode call
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

/** A zip or saved email: the server unpacks it and files each file inside on its own. */
export function isContainerUpload(name: string): boolean {
  return /\.(zip|eml|msg)$/i.test(name.trim());
}

/** Browser-reported MIME type, with a safe fallback when the OS gives none. */
export function contentTypeOf(file: File): string {
  return file.type || 'application/octet-stream';
}
